import React from 'react';
import { Modal, Button, Jumbotron } from 'react-bootstrap';
import { getFileFromS3 } from '../../Services/s3'

interface DocumentPdf {
  documentUrl?: string;
  documentName?: string;
  bucketFilename?: string;
  id: string;
}

interface DocumentReaderProps {
  show: boolean,
  onClose: Function,
  files: DocumentPdf[],
}

const DocumentReader: React.FC<DocumentReaderProps> = ({show, onClose, files}) => {

  const getExt = (name:any) =>
  {
    if(name === undefined) return ""
    let valor = name.split(".")
    return valor[valor.length - 1]
  }
  const handleGetFileSource = (bucketFilename: string) => {
    console.log('Trying to get from bucket')
    return getFileFromS3(bucketFilename, (60 * 5));
  }

  return (
    <Modal size="lg" show={show} onHide={() => onClose()} animation={false}>
      <Modal.Header closeButton>
        <Modal.Title>Documents enviados</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      {files.map((file: DocumentPdf) =>
          {
            return (
              <Jumbotron key={file.id}>
                {file.documentName}
                {(getExt(file.documentName) === "pdf" || getExt(file.documentName) === "PDF") &&
                  <iframe
                    className="embed-responsive-item"
                    src={file.bucketFilename ? handleGetFileSource(file.bucketFilename) : file.documentUrl}
                    width={720}
                    height={550}
                  />
                }
                {(getExt(file.documentName) !== "pdf" && getExt(file.documentName) !== "PDF") &&
                  <img src={file.bucketFilename ? handleGetFileSource(file.bucketFilename) : file.documentUrl}
                    width={720}
                    height={550}
                  />
                }

              </Jumbotron>
          )}
        )
      }
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => onClose()}>
          Tudo certo!
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default DocumentReader;
